import React from 'react';
import styles from '../../settings/configuration/shared/IntelligencePanel.module.scss';
import { catalogFromStatus } from './hireTypes';
import { IntelligenceProductStatus } from '../../../api/ai';

interface IntelligenceCapacityCardsProps {
  status: IntelligenceProductStatus;
  pendingCapacity?: boolean;
  idleLabel?: string;
  onSelect: (capacityId: 'lite' | 'plus' | 'extra') => void;
}

const IntelligenceCapacityCards: React.FC<IntelligenceCapacityCardsProps> = ({
  status,
  pendingCapacity,
  idleLabel = 'por mes',
  onSelect,
}) => {
  const catalog = catalogFromStatus(status);
  return (
    <div className={styles.cards}>
      {catalog.map(item => {
        const id = item.id as 'lite' | 'plus' | 'extra';
        const onTrial = Boolean(status.trialing && status.capacityId === id);
        const active = status.capacityId === id && !onTrial;
        const pendingThis = Boolean(pendingCapacity) && !active && !onTrial;
        return (
          <button
            key={id}
            type="button"
            className={`${styles.card} ${active ? styles.cardActive : ''}`}
            onClick={() => onSelect(id)}
            disabled={pendingThis}
          >
            <span className={styles.cardLabel}>{item.name}</span>
            <span className={styles.cardPrice}>
              {item.monthlyPrice
                ? `$${Number(item.monthlyPrice).toFixed(2)}`
                : active
                  ? '—'
                  : 'Activar'}
            </span>
            <span className={styles.cardMeta}>
              {active
                ? 'Activo'
                : onTrial
                  ? 'En prueba · suscribirse'
                  : pendingThis
                    ? 'Pago en revisión'
                    : typeof item.monthlyCredits === 'number' &&
                        item.monthlyCredits > 0
                      ? `${item.monthlyCredits.toLocaleString()} créd./mes`
                      : idleLabel}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default IntelligenceCapacityCards;
